<template>
    <v-row justify="center">
        <v-dialog v-model="internalDialog" persistent max-width="600">
            <v-card>
                <v-card-title class="headline">
                    <v-icon color="red" class="mr-2">mdi-alert</v-icon>
                    <span style="color: red">{{ title }}</span>
                </v-card-title>
                <v-card-text>
                    <p class="mb-3">
                        {{ message }}
                    </p>
                    <v-card outlined class="pa-3 mb-3" v-if="avisoConflitante">
                        <div><strong>{{ messageLabel }}:</strong> {{ avisoConflitante.titulo }}</div>
                        <div><strong>{{ startLabel }}:</strong> {{ avisoConflitante.dt_inicio_vigencia_extenso }}</div>
                        <div><strong>{{ endLabel }}:</strong> {{ avisoConflitante.dt_fim_vigencia_extenso || undefinedLabel }}</div>
                        <div><strong>{{ categoryLabel }}:</strong> {{ avisoConflitante.descricao_categoria }}</div>
                    </v-card>
                    <p>
                        <strong style="color: red">{{ warningMessage }}</strong>
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey" text @click="handleCancel">{{ cancelText }}</v-btn>
                    <v-btn color="red" dark @click="handleConfirm">{{ confirmText }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
export default {
    name: 'ReplaceDialog',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: 'Conflito de Vigência'
        },
        message: {
            type: String,
            default: ''
        },
        warningMessage: {
            type: String,
            default: ''
        },
        avisoConflitante: {
            type: Object,
            default: null
        },
        messageLabel: {
            type: String,
            default: 'Mensagem'
        },
        startLabel: {
            type: String,
            default: 'Início'
        },
        endLabel: {
            type: String,
            default: 'Fim'
        },
        categoryLabel: {
            type: String,
            default: 'Categoria'
        },
        undefinedLabel: {
            type: String,
            default: 'Indefinido'
        },
        cancelText: {
            type: String,
            default: 'Cancelar'
        },
        confirmText: {
            type: String,
            default: 'Substituir'
        }
    },
    computed: {
        internalDialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        handleCancel() {
            this.$emit('cancel');
        },
        handleConfirm() {
            this.$emit('confirm');
        }
    }
}
</script>

